import { ClaimRecord } from './ClaimRecord'
import { SimplifiedBenefitPlanItem } from './InsurancePlan'

export enum AnalyticsElement {
  SUBMIT = 'SUBMIT',
  DOWNLOAD = 'DOWNLOAD',
  MORE_INFO = 'MORE_INFO',
  START = 'START',
  CLOSE = 'CLOSE',
  CANCEL = 'CANCEL',
  CONTINUE = 'CONTINUE',
  OTHER = 'OTHER',
}

export type AnalyticsOptions = {
  index?: number
  description?: string
}

export type AnalyticsInsuranceMethod = 'standard' | 'memberid'

export type AnalyticsRejectError =
  | 'CLAIM_REJECTED'
  | 'CLAIM_ACKNOWLEDGED'
  | 'CLAIM_ACKNOWLEDGED_NULLIFIED'
  | 'SUBMIT_CLAIM_NO_RETRY_ERROR'
  | 'TIMEOUT_RETRY'
  | 'LIMIT_REACHED'
  | 'INSURER_ERROR'
  | 'INSUFFICIENT_COVERAGE'
  | 'REQUEST_QUOTE_ERROR'
  | 'REQUEST_QUOTE_RESTRICTED'
  | 'SUBMIT_QUOTE_ERROR'
  | 'SUBMIT_QUOTE_NO_RETRY_ERROR'
  | 'REFUSE_QUOTE_ERROR'
  | 'TIME_EXCEEDED_ERROR'
  | 'TOO_MANY_ATTEMPTS'
  | 'INSURANCE_MEMBER_NOT_FOUND'
  | 'MULTIPLE_INSURANCE_MEMBERS_FOUND'
  | 'GENERIC_ERROR'

export type AnalyticsApplyPayload = {
  claimRecord?: ClaimRecord
  benefitPlans?: SimplifiedBenefitPlanItem[]
  isMemberIdForm?: boolean
}

export type AnalyticsRejectPayload = {
  insurerName?: string
  claimRecord?: ClaimRecord
  isMemberIdForm?: boolean
  error?: AnalyticsRejectError
}

export type InsuranceOpenEventData = {
  type: 'open'
  id: 'Impression'
  Page_Section2: 'InsurancePanel'
}

export type InsuranceAcceptEventData = {
  type: 'accept'
  id: 'Event'
  Events_InsuranceApplied: '1'
  Order_InsuranceCode: string
  Order_InsuranceAmount: string
  Order_InsuranceMethod: AnalyticsInsuranceMethod
  Order_InsuranceBenefits: string
}

export type InsuranceEventErrorType = 'User' | 'Server'

export type InsuranceRejectEventData = {
  type: 'reject'
  id: 'Event'
  Events_InsuranceTentative: '1'
  Order_InsuranceCode: string
  Order_InsuranceMethod: AnalyticsInsuranceMethod
  Error_Source?: InsuranceEventErrorType
  Error_Code?: 'Insurance'
  Error_Message?: string
  error?: AnalyticsRejectError
}

export type AnalyticsEvent = InsuranceOpenEventData | InsuranceAcceptEventData | InsuranceRejectEventData
